import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";

export class WidgetsNoneModel extends WidgetsAbstract {
    readonly icon: string = 'crop_16_9';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.NONE;
    readonly badge: string = 'N';
    readonly placeholderClassName: string = 'column-placeholder';
    readonly name: string = 'None';
    
    toJSON() : any {
        return {
            badge: this.badge,
            widgetType: this.widgetType, 
            id: this.id,
            parentId: this.parentId ? this.parentId : undefined,
            name: this.name,
        };
    }

    /**
     * Clone from a provided origin.
     * @note Id/uuid is not cloned * 
     * @param origin
     * @returns the cloned node
     */
     cloneFrom(origin: WidgetsNoneModel) : WidgetsNoneModel {       
        if (origin.parentId) {
            this.parentId = origin.parentId;
        }
        this.isSelected = origin.isSelected;
        return this;
    }
}
